import { Button } from '@mokoboko/components';

import { WAITLIST_ACTION_LABEL, type WaitlistAction } from '@/helpers/waitlist';

type ClassActionButtonProps = {
  isFullyBooked: boolean;
  isBooked: boolean;
  waitlistAction: WaitlistAction | null;
  onViewBookingClick: () => void;
  onWaitlistClick: () => void;
  onBookClick: () => void;
  isProcessing?: boolean;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
};

export const ClassActionButton = ({
  isFullyBooked,
  isBooked,
  waitlistAction,
  onViewBookingClick,
  onWaitlistClick,
  onBookClick,
  isProcessing,
  size = 'md',
  fullWidth,
}: ClassActionButtonProps) => {
  const isBook = !isBooked && !waitlistAction;
  const variant =
    isBooked || waitlistAction === 'view' ? 'secondary-gray' : 'primary';
  const label = isBooked
    ? 'View booking'
    : waitlistAction
      ? WAITLIST_ACTION_LABEL[waitlistAction]
      : isFullyBooked
        ? 'Fully booked'
        : 'Book class';
  const handler = isBooked
    ? onViewBookingClick
    : waitlistAction
      ? onWaitlistClick
      : onBookClick;

  return (
    <Button
      variant={variant}
      onClick={(e) => {
        e.stopPropagation();
        handler();
      }}
      size={size}
      fullWidth={fullWidth}
      disabled={isBook && (isFullyBooked || !!isProcessing)}
      isProcessing={isBook && isProcessing}
    >
      {label}
    </Button>
  );
};
